export default __webpack_public_path__ + "assets/565acb5175434c2ab86e02d6901317fe.jpg";